import { type EditorPlugin } from '../../types/aha-editor';
import { type Descendant, type Editor, Element, Text, Transforms } from 'slate';
import markdownit from 'markdown-it';
import { HtmlSerializer } from '../../serialization/HtmlSerializer';
import { isParagraphElement } from '../../types/guards';

const hasFormatting = (children: Descendant[]) => {
  for (const child of children) {
    if (Element.isElement(child) && !isParagraphElement(child)) {
      return true;
    }
    if (Text.isText(child)) {
      const { text, ...marks } = child;
      if (Object.keys(marks).length > 0) {
        return true;
      }
    }
    if (Element.isElement(child) && hasFormatting(child.children)) {
      return true;
    }
  }
  return false;
};

// Paste or drop for HTML.
const PasteMarkdownPlugin: EditorPlugin = {
  name: 'Paste markdown plugin',
  insertData: (editor: Editor, data: DataTransfer, controller) => {
    for (const item of data.items) {
      if (item.type === 'text/plain' && item.kind === 'string') {
        const text = data.getData('text/plain');
        const html = markdownit({ breaks: true }).render(text);
        const serializer = new HtmlSerializer(
          editor,
          controller?.serializerOptions ?? {}
        );
        const fragment = serializer.deserialize(html).children;

        if (
          hasFormatting(fragment) ||
          (controller?.serializerOptions?.alwaysAcceptMarkdown &&
            !data.getData('application/x-aha-v2-fragment'))
        ) {
          Transforms.insertFragment(editor, fragment);
          return true;
        }
      }
    }

    return false;
  },
};

export default PasteMarkdownPlugin;
